enum CompanyPageTabsEnums {
  ADMIN = 'admin',
  AUTOMATIONS = 'automations',
  CUSTOM_FIELDS = 'customFields',
  DATA_UPLOADS = 'dataUploads',
  INVITES = 'companyInvites',
  LABELS = 'labels',
  TEAM_MEMBERS = 'companyTeamMembers',
  CONFIDENCE_LEVELS = 'confidenceLevels',
}

export default CompanyPageTabsEnums;
